import React, { useContext, useEffect } from 'react';
import ContractsList from './Contracts/ContractsList';
import SectionHeader from '../../../components/SectionHeader/SectionHeader';
import { FormattedMessage } from 'react-intl';
import CardRow from '../../../components/CardRow/CardRow';
import CardRowCard from '../../../components/CardRow/CardRowCard';
import { DashboardStateStore } from '../store/dashboardStore';
import { useGetAllContracts } from '../hooks/api/contractsApi';
import { dashboardStoreActions } from '../store/dashboardStoreAction';
import { materialUIThemeUserDashboard } from '../style/materialUIThemeUserDashboard';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';
import useBreadCrumbs from '../../../hooks/breadCrumbs/useBreadCrumbs';
import { useParams } from 'react-router';
import useAppContext from '../../../hooks/context/useAppContext';
import Section from './Section';
import Products from './Products/Products';
import Purchases from './Purchases/Purchases';
import Prices from './Prices/Prices';

const Dashboard = () => {
  useBreadCrumbs(<FormattedMessage id={'app.customerdashboard.label'} />);
  const { dispatch } = useContext(DashboardStateStore);
  const { getAllContracts } = useGetAllContracts();
  let { customerId } = useParams();
  const { getUser } = useAppContext();

  if (!customerId) {
    const customers = getUser().customers;
    if (customers.length > 0) {
      customerId = customers[customers.length - 1].id;
    }
  } else {
    customerId = parseInt(customerId);
  }

  useEffect(() => {
    (async () => {
      dispatch({
        type: dashboardStoreActions.GET_GLOBAL_DATA_LOADING,
        loading: true,
      });
      try {
        const { data } = await getAllContracts(customerId);
        const output = data.reduce((accumulator, item) => {
          if (!accumulator[item.commodity.id]) {
            accumulator[item.commodity.id] = {};
          }
          if (!accumulator[item.commodity.id][item.contractPeriod]) {
            accumulator[item.commodity.id][item.contractPeriod] = item.id;
          }

          return accumulator;
        }, {});

        dispatch({
          type: dashboardStoreActions.GET_GLOBAL_DATA,
          data: output,
        });
      } catch (e) {
        dispatch({
          type: dashboardStoreActions.GET_GLOBAL_DATA_ERROR,
          data: e,
        });
      }
    })();
  }, [customerId, dispatch, getAllContracts]);

  return (
    <MuiThemeProvider
      theme={(theme) => ({
        ...theme,
        ...materialUIThemeUserDashboard,
      })}>
      <Section>
        <SectionHeader>
          <FormattedMessage id={'app.contracts.label'} />
        </SectionHeader>
        <CardRow>
          <CardRowCard>
            <ContractsList customerId={customerId} />
          </CardRowCard>
        </CardRow>
      </Section>
      <Products />
      <Prices customerId={customerId} />
      <Purchases customerId={customerId} />
    </MuiThemeProvider>
  );
};

export default Dashboard;
